import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 10,
  pageOptions: [10, 20, 50],
  totalRows: 1,
  sortOptions: [],
  options: [],
  fields: [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'desc', label: 'Description' },
    { key: 'created_at', label: 'Created At' },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action' },
  ],
  items: [],
})

// getters
const getters = {}

// actions
const actions = {
  getAll({ commit }, params) {
    const param = { status: 'master/roles', params }
    useIPA.get(param).then(response => {
      const role = {
        rows: response.data.data,
      }
      const { pagination } = response.data
      commit('setData', { ...role })
      commit('setPagination', pagination)
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/roles/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        name: formData.text_1,
        desc: formData.text_2,
        role_privileges: {
          create: formData.role_privilege.map(item => ({ privilege_id: item.id, role_id: formData.id })),
        },
        status: 'AC',
      }
      console.log(rawData)
      const param = { rawData, url: 'internal/master/roles', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'user-role' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/roles', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
}

// mutations
const mutations = {
  setData(state, role) {
    role.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.items = role.rows
    state.totalRows = role.rows.length
    state.options = []
    for (let i = 0; i < role.rows.length; i++) {
      const option = []
      for (const key in role.rows[i]) {
        if (key === 'id') {
          option.value = role.rows[i][key]
        } else if (key === 'name') {
          option.title = role.rows[i][key]
        } else if (key === 'id') {
          option.oid = role.rows[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
